import React from 'react';
import cn from "../../../../lib/bem";
import ButtonModalComponent from './../../../../components/buttonModal/buttonModal_component';

import './seccion_conoce.scss';

const SeccionConoce = () => {

    const classes = cn("seccionConoce");

    return ( 
        <div className={classes()}>
            <div className={classes('seccionConoceDiv')}>
                <p className={classes('seccionConoceTitle')} ><b>Conoce todo sobre los seguros de vida</b></p>
                <div className={classes('seccionConoceGrid')}>
                    <ButtonModalComponent 
                        label={"btnModaPrimero"}
                        tipo={"button-white"}
                        disabled={false}
                        nombre={"¿Qué cubre?"}
                        title={"¿Qué cubre?"}
                        body={
                            <div className={classes('buttonModalBody')} >
                                <p>Devolución de prima más una rentabilidad garantizada al finalizar el plazo. </p>
                                <p><b>En caso de fallecimiento</b></p>
                                <ul>
                                    <li>El monto de la cobertura de vida en caso de fallecimiento del asegurado, por causas naturales o accidentales, será equivalente al 5% de la devolución que corresponde al finalizar la póliza.</li>
                                    <li>Adicionalmente, se pagará el monto de la prima única más la rentabilidad acumulada hasta el momento del fallecimiento.</li>
                                </ul>
                            </div>
                         }
                    />
                    <ButtonModalComponent 
                         label={"btnModaSegundo"}
                         tipo={"button-white"}
                         disabled={false}
                         nombre={"¿Qué no cubre?"}
                         title={"¿Qué no cubre?"}
                         body={
                            <div className={classes('buttonModalBody')} >
                                <p>Este seguro no cubre el fallecimiento del asegurado si este se produjera como consecuencia del siguiente caso:</p>
                                <p><b>Acto criminal de beneficiarios</b></p>
                                <ul>
                                    <li>Acto criminal en el que resulte responsable un beneficiario, en cuyo caso, el beneficio correspondiente a la cobertura del Seguro de Vida y el Beneficio por Fallecimiento que correspondía al beneficiario incriminado se pagará a los beneficiarios con exclusión de dicho beneficiario, en proporción a la participación que les fuese asignada.</li>
                                </ul>
                            </div>
                         }
                    />
                    <ButtonModalComponent 
                        label={"btnModaTercero"}
                        tipo={"button-white"}
                        disabled={false}
                        nombre={"Características y beneficios adicionales"}
                        title={"Características y beneficios adicionales"}
                        body={
                            <div className={classes('buttonModalBody')} >
                                <p><b>Características</b></p>
                                <p className='pagh'>Retorno de inversión</p>
                                <ul>
                                    <li>Obtén un retorno 100% garantizado al finalizar el periodo de contratación de 1, 2, 3 o 4 años. El retorno es acreditado a una tasa garantizada y fija durante la vigencia de la póliza.</li>
                                </ul>
                                <p className='pagh'>Retiro anticipado</p>
                                <ul>
                                    <li>Posibilidad de retiro anticipado del dinero invertido en cualquier momento de la vigencia de la póliza. Se aplicará un recargo según el plazo pendiente de vigencia de la póliza que se indica al momento de la cotización.</li>
                                </ul>
                                <p className='pagh'>Libre de impuestos</p>
                                <ul>
                                    <li>El Seguro Fondo Vida Garantizado se encuentra exonerado de pago del Impuesto a la Renta sobre las ganancias.</li>
                                </ul>
                                <p className='pagh'>Beneficiarios designados</p>
                                <ul>
                                    <li>La libre elección de beneficiarios permite al cliente definir en vida la entrega de un patrimonio a familiares que no necesariamente son herederos legales; además, tiene la opción de cambiar a sus beneficiarios durante la vigencia de la póliza.</li>
                                </ul>
                                <p><b>Beneficios adicionales</b></p>
                                <ul>
                                    <li>Acceso al programa ¨Salud en Casa¨</li>    
                                    <li>Aprovecha la afiliación al programa "Salud en Casa" y protege tu salud con los distintos servicios:</li>
                                    <ul>
                                        <li>Ambulancia para traslados de emergencia</li>
                                        <li>Consultas médicas generales por videollamada ( Conoce más detalles sobre este beneficio <a href='https://www.pacifico.com.pe/seguros/vida/programa-salud-en-casa' target='_blank'rel='noreferrer' >aquí</a>)</li>
                                        <li>Acceso al programa de descuentos y precios exclusivos</li>
                                        <li>Con "Programa de beneficios de Pacifico" podrás acceder a grandes descuentos y precios exclusivos en más de 50 establecimientos en 5 categorías:</li>
                                        <ul>
                                            <li>Día a día: Descuentos útiles y prácticos que te servirán en más de una ocasión.</li>
                                            <li>Cuida tu salud: Beneficios médicos complementarios a tus coberturas, para mantenerte y sentirte bien.</li>
                                            <li>Date un gusto: Beneficios en establecimientos exclusivos para engreír tu paladar.</li>
                                            <li>Sal de la rutina: Las mejores opciones de esparcimiento y aprendizaje para que compartas momentos únicos.</li>
                                            <li>Desconéctate: Tomar un descanso y pasarla genial dentro y fuera de casa pensado en tus hábitos.</li>
                                            <li>Conoce más detalles sobre el Programa de Beneficios de Pacifico <a href='https://www.pacifico.com.pe/programadebeneficios' target='_blank'rel='noreferrer' >aquí</a>.</li>
                                        </ul>
                                    </ul>
                                </ul>
                            </div>
                        }
                    />
                    <ButtonModalComponent 
                        label={"btnModaCuarto"}
                        tipo={"button-white"}
                        disabled={false}
                        nombre={"¿Cómo usar mi seguro de vida?"}
                        title={"¿Cómo solicitar la cobertura del seguro?"}
                        body={
                            <div className={classes('buttonModalBody')} >
                                <p>En caso de fallecimiento o invalidez, los beneficiarios o asegurados pueden registrar el siniestro y solicitar los beneficios en nuestra nueva plataforma.</p>
                                <a href='https://www.pacifico.com.pe/seguros/vida/como-usar?origen=Seguros-ParaTiYTuFamilia-FondoVidaGarantizado-ConoceTodo-NA-04-Boton-ComoSolicitarCoberturaSeguro' target='_blank'rel='noreferrer' >Cómo usar el seguro</a>
                            </div>
                        }
                    />
                </div>
                <br/><br/>
            </div>
        </div>
    );
}
 
export default SeccionConoce;